import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { editPass, chkPass } from "../../../../../features/mobile/accountSlice";
import { regPass } from "../../../components/logic";
import { toast } from "react-toastify";
import toastCommonProps from "../../../../../common/toast";
import HeadCont from "../../../components/common/HeadCont";
import InputBox from "../../../components/common/InputBox";
import Btn from "../../../components/common/Btn";

const EditPass = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bottomRef = useRef(null);
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [status, setStatus] = useState("current"); //current: verify current password, new: verify new password
  const [currentPass, setCurrentPass] = useState(null);
  const [pwd, setPwd] = useState({ pass: "", again: "" });
  const [active, setActive] = useState("ready");
  const [active1, setActive1] = useState("ready");
  const [active2, setActive2] = useState("ready");
  const [errorMsg, setErrorMsg] = useState(
    "Please enter at least 6 characters (letters and numbers)"
  );
  const [errorMsg2, setErrorMsg2] = useState({
    msg1: "Please enter at least 6 characters (letters and numbers)",
    msg2: "",
  });
  const passRef = useRef(null);
  const againRef = useRef(null);

  const onChangeInput = (e) => {
    setCurrentPass(e.target.value);
    if (!regPass(e.target.value)) {
      setErrorMsg("Please enter at least 6 characters (letters and numbers)");
      setActive("ready");
    } else {
      setErrorMsg("");
      setActive("on");
    }
  };

  const scrollAction = () => {
    const timer = setTimeout(
      () =>
        bottomRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        }),
      500
    ); //delayed response
    return () => clearTimeout(timer);
  };

  const onChangeInput1 = (e) => {
    setPwd({ ...pwd, pass: e.target.value });
    if (!regPass(e.target.value)) {
      setErrorMsg2({
        msg1: "Please enter at least 6 characters (letters and numbers)",
        msg2: "",
      });
      setActive1("ready");
      setActive2("ready");
    } else {
      scrollAction();
      setErrorMsg2({ msg1: "", msg2: "" });
      setActive1("on");
    }
  };

  const onChangeInput2 = (e) => {
    setPwd({ ...pwd, again: e.target.value });
    if (pwd.pass !== e.target.value) {
      setErrorMsg2({
        ...errorMsg2,
        msg2: "Please re-enter your password to confirm",
      });
      setActive2("ready");
    } else {
      if (active1 === "on") {
        setErrorMsg2({ ...errorMsg2, msg2: "Passwords match" });
        setActive2("on");
      } else setActive2("ready");
    }
  };

  const onDeleteValue = (type) => {
    if (type === "pass") {
      setPwd({ pass: "", again: "" });
      setErrorMsg2({ ...errorMsg2, msg1: "" });
      passRef.current?.focus();
      setActive1("ready");
      setActive2("ready");
    } else {
      setPwd({ ...pwd, again: "" });
      setErrorMsg2({ ...errorMsg2, msg2: "" });
      againRef.current?.focus();
    }
  };
  // * Save password change
  const onSavePass = (e) => {
    e.preventDefault();
    let params = {
      userId: loginInfo.userId,
      orgPass: currentPass,
      newPass: pwd.pass,
    };
    dispatch(editPass(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          toast(
            <p>Password has been changed</p>,
            toastCommonProps("bottom-center", "toast_alert", 1000)
          );
          setCurrentPass("");
          setPwd({ pass: "", again: "" });
          const timer = setTimeout(() => navigate(-1), 500);
          return () => clearTimeout(timer);
        } else {
          setErrorMsg(res.error);
          setErrorMsg2({
            msg1: "Please enter at least 6 characters (letters and numbers)",
            msg2: "",
          });
          setStatus("current");
          setCurrentPass("");
          setPwd({ pass: "", again: "" });
          setActive("ready");
          setActive1("ready");
        }
      })
      .catch((err) => console.log(err));
  };

  // * Check current password
  const onCheckPass = () => {
    let params = {
      userId: loginInfo.userId,
      orgPass: currentPass,
    };
    dispatch(chkPass(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          setStatus("new");

          setCurrentPass("");
          setPwd({ pass: "", again: "" });
        } else {
          setErrorMsg(res.error);
          setErrorMsg2({
            msg1: "Please enter at least 6 characters (letters and numbers)",
            msg2: "",
          });
          setStatus("current");
          setCurrentPass("");
          setActive("ready");
          setActive1("ready");
          //   setPwd({ pass: "", again: "" });
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    let focused = true;
    if (focused && status === "new") {
      passRef.current?.focus();
    }
    return () => (focused = false);
  }, [status]);

  return (
    <>
      <HeadCont title={"Change Password"} underline={true} />
      <section className="px-6 py-8 mb-6 mt-14">
        <p className="text-subtitle3 text-gray_180">
          {status === "current"
            ? "Please enter your current password"
            : "Please enter your new password"}
        </p>

        {status === "current" ? (
          // * Verify current password
          <>
            <div className="mt-8 space-y-4">
              <InputBox
                option="common"
                type="password"
                placeholder={"Current password"}
                onChangeInput={onChangeInput}
                errorMsg={errorMsg}
                value={currentPass}
                setValue={setCurrentPass}
                active={active}
              />
              <Btn
                option={"bottom"}
                bgColor={"bg-main"}
                textColor={"text-white font-semibold"}
                borderColor={"border border-main"}
                title={"Confirm Password"}
                active={errorMsg === "" ? "on" : "ready"}
                onAction={onCheckPass}
              />
            </div>
          </>
        ) : (
          <div className="mt-8 space-y-4">
            <form
              onSubmit={
                active1 === "on" && active2 === "on"
                  ? onSavePass
                  : (e) => e.preventDefault()
              }
              className="pb-24 space-y-6"
            >
              <InputBox
                option="pass"
                refName={passRef}
                id={"pass"}
                nameTitle={"pass"}
                placeholder={"Password"}
                onChangeAction={(e) => onChangeInput1(e)}
                value={pwd.pass || ""}
                active={active1}
                onClickAction={() => onDeleteValue("pass")}
                errorMsg={errorMsg2.msg1}
              />
              <InputBox
                option="pass"
                refName={againRef}
                id={"again"}
                nameTitle={"again"}
                placeholder={"Confirm password"}
                onChangeAction={(e) => onChangeInput2(e)}
                value={pwd.again || ""}
                active={active2}
                onClickAction={() => onDeleteValue("again")}
                errorMsg={errorMsg2.msg2}
              />
              <Btn
                option={"bottom"}
                bgColor={"bg-main"}
                textColor={"text-white font-semibold"}
                borderColor={"border border-main"}
                title={"Save Password"}
                active={active1 === "on" && active2 === "on" ? "on" : "ready"}
              />
            </form>
            <div ref={bottomRef} className="h-[40px]"></div>
          </div>
        )}
      </section>
    </>
  );
};

export default EditPass;
